import cn from "classnames";
import { useTranslation } from "react-i18next";

import { CALCULATOR_SCENARIO_VARIANT } from "constants/calculator";

import { convertValueToLocale } from "helpers/convertValueToLocale";

import { Typography } from "shared/ui/components/Typography";

import styles from "./RentalYieldCard.module.scss";

const RentalYieldCard = ({ calculation }: { calculation: any }) => {
  const { t, i18n } = useTranslation();

  const language = i18n.language;

  return (
    <div className={styles.chartItem}>
      <Typography className={styles.chartTitle} variant="bodyS" weight="semiBold">
        {t("calculator_pro_page.results.title")}
      </Typography>
      <Typography
        className={cn({
          [styles.chartTitlePositive]:
            calculation?.rentalYields?.investmentObjectRentalYield
              ?.conclusionVariant === CALCULATOR_SCENARIO_VARIANT.POSITIVE,
          [styles.chartTitleNeutral]:
            calculation?.rentalYields?.investmentObjectRentalYield
              ?.conclusionVariant === CALCULATOR_SCENARIO_VARIANT.NEUTRAL,
          [styles.chartTitleNegative]:
            calculation?.rentalYields?.investmentObjectRentalYield
              ?.conclusionVariant === CALCULATOR_SCENARIO_VARIANT.NEGATIVE,
        })}
        variant="bodyM"
        weight="semiBold"
      >
        {convertValueToLocale(
          calculation?.rentalYields?.investmentObjectRentalYield?.rentalYield *
            100,
          2,
          "%"
        )}
      </Typography>

      <Typography variant="bodyXS" className={styles.chartDescription}>
        {
          calculation?.rentalYields?.investmentObjectRentalYield?.conclusion[
            language
          ]
        }
      </Typography>
    </div>
  );
};

export default RentalYieldCard;
